import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';
import Nothing_here from './Nothing_here';
import Select from 'react-dropdown-select';
import addresses_image from '../assets/images/addresses-image.svg';



import Headermain from './Headermain';
import Slidemenu from './Slidemenu';

const selectCity = [
    { label: 'Billing Address', value: 'Billing Address' },
    { label: 'North Goa', value: 'North Goa' },
    { label: 'Palakkad', value: 'Palakkad' },
    { label: 'Dunstan', value: 'Dunstan' },
    { label: 'Euroa', value: 'Euroa' },
    { label: 'Bighorn', value: 'Bighorn' },
    { label: 'Acadia', value: 'Acadia' }
]

class No_addresses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Credits, Promos & Gift Cards</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <Slidemenu prop={this.props} />
                                <div className="addresses content">
                                    <h3>Addresses</h3>
                                    <a href="" title="Add a new address" data-bs-toggle="modal" data-bs-target="#exampleModal" className="add-address">Add New Address</a>

                                    <Nothing_here wrapperClass="common-nothing-wrapper no-addresses-wrapper" imageAreaClass="image-area-box" imgSrc={addresses_image} descriptionClass="common-nothing-description" descriptionText="No Address added yet" btnClass="common-nothing-btn add-member-btn" btnText="+ Add Address" modal="modal" modalTarget="#exampleModal"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="edit_form modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="exampleModalLabel">Edit Address</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <form id="address_form" method="post">
                                    <div className="form-group">
                                        <label htmlFor="addressLine1" className="label">Address Line 1</label>
                                        <input type="text" name="name" className="form-control" required="required" id="addressLine1"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="addressLine2" className="label">Address Line 2</label>
                                        <input type="text" name="name" className="form-control" required="required" id="addressLine2"/>
                                    </div>
                                    <div className="form-group select-dropdown-box">
                                        <label htmlFor="city" className="label">City</label>
                                        <Select className="form-control" id="city" options={selectCity} onChange={(value) => console.log(value)} />
                                    </div>
                                    <div className="form-group select-dropdown-box">
                                        <label htmlFor="state" className="label">State</label>
                                        <Select className="form-control" id="state" options={selectCity} onChange={(value) => console.log(value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="pincode" className="label">PIN Code</label>
                                        <input type="num" id="pincode" name="name" className="form-control" required="required" />
                                    </div>
                                    <div className="footer-btns">
                                        <button className="form_btn save">Save</button>
                                        <button className="form_btn del">Delete</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default No_addresses;